import { FC } from "react";

import { BulkImportContent } from "./BulkImportContent";

import { BulkImportType } from "components/server-types";
import { t } from "i18n/i18n";
import { Modal } from "mds/components/Modal";

interface BulkImportModalProps {
  importType: BulkImportType;
  onClose: () => void;
}

export const BulkImportModal: FC<BulkImportModalProps> = ({ importType, onClose }) => {
  return (
    <>
      <div className="modal-backdrop" onClick={onClose} />

      <Modal
        className="bulk-import-modal w-[598px]"
        title={t(`home.settings.bulk_import_modal.types.${importType}`)}
        hideCancelConfirmButtons
        onClose={onClose}
      >
        <div className="modal-body">
          <BulkImportContent importType={importType} onClose={onClose} />
        </div>
      </Modal>
    </>
  );
};
